import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Entity, Page } from "../types";

interface NavButtonsProps {
  pages: Entity<Page>;
}

const NavButtons: React.FC<NavButtonsProps> = ({ pages }) => {
  const slugs = pages.allIds.map((id) => {
    const page = pages.byId[id];
    return page ? page.short : "";
  });
  const location = useLocation();

  const [pageList, setPageList] = useState([...slugs, "summary"]);
  const [prev, setPrev] = useState("");
  const [next, setNext] = useState("");

  useEffect(() => {
    const slug = location.pathname.substring(1);
    const idx = pageList.indexOf(slug);
    const isValidSlug = idx !== -1;
    if (!isValidSlug) return;

    const prevLink = idx - 1 <= -1 ? "" : (pageList[idx - 1] as string);
    const nextLink =
      idx + 1 >= pageList.length ? "" : (pageList[idx + 1] as string);
    setPrev(prevLink);
    setNext(nextLink);
  }, [location]);

  return (
    <div className="nav-buttons">
      <NavBtn className="nav-prev-btn" slug={prev} text="Prev" />
      <NavBtn className="nav-next-btn" slug={next} text="Next" />
    </div>
  );
};

interface NavBtnProps {
  className: string;
  slug: string;
  text: string;
}

const NavBtn: React.FC<NavBtnProps> = ({ className, slug, text }) => {
  if (slug === "") return null;
  return (
    <Link className={className} to={`/${slug}`}>
      {text}
    </Link>
  );
};

export default NavButtons;
